// TODO: optimize services that iterates through collection each time.
// Jest tests fail if `window.SchoolSettings` is outside of the functions.
import * as _ from "lodash-es";
import parsePhoneNumber from "libphonenumber-js";

export const getGradeLabel = (grade) => {
  const grades = _.keyBy(window.SchoolSettings.grade_options.all_entry_grades, "value");
  return grades[grade] && grades[grade].text;
};

export const getAttendanceType = (attendanceTypeId) =>
  window.SchoolSettings.attendance_types.find((item) => item.id === attendanceTypeId);

export const getAttendanceTypeName = (attendanceTypeId) => {
  const attendanceType = getAttendanceType(attendanceTypeId);
  return attendanceType && attendanceType.name;
};

export const getAttendanceTypeOptions = () =>
  window.SchoolSettings.attendance_types.map((at) => ({
    text: at.name,
    value: at.id,
    is_enabled: at.is_enabled,
  }));

export const getParentsRelationshipName = (parentRelationshipId) => {
  const parentRelationship = window.SchoolSettings.parents_relationships.find(
    (item) => item.id === parentRelationshipId,
  );
  return parentRelationship && parentRelationship.name;
};

export const getParentsRelationshipOptions = () =>
  window.SchoolSettings.parents_relationships.map((at) => ({
    text: at.name,
    value: at.id,
  }));

export const formatMobilePhone = (mobilePhone) => {
  if (!mobilePhone) {
    return mobilePhone;
  }
  const result = parsePhoneNumber(mobilePhone);
  if (!result || !result.isValid()) {
    return mobilePhone;
  }
  return window.SchoolSettings.is_international_mobile_phone_format
    ? result.formatInternational()
    : result.formatNational();
};

export const hasFeature = (feature) =>
  window.SchoolSettings.feature_flags.includes(feature);

export const getResidencyStatusOptions = () =>
  window.SchoolSettings.residency_status_options;

export const getResidencyStatusLabel = (residencyStatus) =>
  _.isNil(residencyStatus)
    ? ""
    : _.keyBy(getResidencyStatusOptions(), "value")[residencyStatus].text;

export const getEnabledResidencyStatusOptions = () =>
  getResidencyStatusOptions().filter((option) => option.is_enabled);

export const isCurrentCountry = (country) =>
  country && country.id === window.SchoolSettings.country.id;
